//angular imports
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

//local imports
import { AbstractCategoryModel } from '@app/catalog-common';

@Component({
  selector: 'category-item',
  templateUrl: './category-item.component.html',
  styleUrl: './category-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CategoryItemComponent {
  public category = input.required<AbstractCategoryModel>();
}
